export const ACCEPTED_UTM_PARAMS = [
  'utm_id',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_source_platform',
  'utm_term',
  'utm_content',
]
export const ACCEPTED_GOOGLE_ADS_PARAMS = ['gclid', '_gl']

// TODO: Figure out a way to properly type env vars without trailing !s (non-null assertion operator)
export const IFRAME_URL = process.env.IFRAME_URL! // This is the entrypoint for the `widgets` SPA
export const IFRAME_ID = 'bw-widget-iframe'
export const IFRAME_CLASS = 'bw-widget-styles'
export const IFRAME_LOADER_CLASS = 'iframe-loader'
export const SNIPPET_SELECTOR = '.mindbody-widget'
export const SNIPPET_PROCESSED_ATTRIBUTE = 'data-bw-processed'
export const UNIQUE_WINDOW_IDENTIFIER = 'bw-widget-unique-identifier'
export const MODAL_BACKDROP_CLASS = 'bw-widget-modal-backdrop'
export const MODAL_CLOSE_BUTTON_CLASS = 'bw-widget-modal-close'
export const MODAL_DIALOG_CLASS = 'bw-widget-modal-dialog'
export const MODAL_CLAIMED_WINDOW_IDENTIFIER = 'bw-widget-modal-claimed'
export const MODAL_DISMISSED_STORAGE_KEY_PREFIX = 'bw-widget-modal-dismissed-'
export const MS_PER_DAY = 24 * 60 * 60 * 1000
export const DEFAULT_MODAL_FREQUENCY_DAYS = '7'
export const MAX_MODAL_FREQUENCY_DAYS = 365
export const DEFAULT_MODAL_DELAY_SECONDS = '3'
export const MAX_MODAL_DELAY_SECONDS = 120
export const DEFAULT_ERROR_MESSAGE =
  'Please double check your Mindbody Branded Web Widget Snippet and try again.'
export const WIDGET_TYPES = {
  Appointments: {
    type: 'Appointments',
    entryPoint: 'services',
  },
  Schedules: {
    type: 'Schedules',
    entryPoint: 'schedule',
  },
  Pricing: {
    type: 'Pricing',
    entryPoint: 'pricing',
  },
  Registration: {
    type: 'Registration',
    entryPoint: 'form',
  },
  Enrollments: {
    type: 'Enrollments',
    entryPoint: 'enrollments',
  },
  Prospect: {
    type: 'Prospect',
    entryPoint: 'form',
  },
} as const
